<template>
  <div class="content">
    <content-header title="ご購入の流れ" />
    <div class="content-body">
      <div class="content-flow flow-green">
        ① <router-link to="/contact">お見積りフォーム</router-link>
        よりご希望商品と数量を入力して送信してください。（お客様）
      </div>
      <div class="content-flow-arrow">▼</div>
      <div class="content-flow flow-blue">
        ② 内容確認後、お見積りを送信します。（弊社）
      </div>
      <div class="content-flow-arrow">▼</div>
      <div class="content-flow flow-green">
        ③ お見積り金額確認後、弊社まで注文の連絡をしてください。（お客様）
      </div>
      <div class="content-flow-arrow">▼</div>
      <div class="content-flow flow-blue">
        ④ 選択いただいたお支払い方法かで決済処理を行います。（弊社）
      </div>
      <div class="content-flow-arrow">▼</div>
      <div class="content-flow flow-blue">
        ⑤ 商品を発送します。
        ※前払い銀行振り込み時は、入金確認後商品を発送します。（弊社）
      </div>
    </div>
  </div>
</template>

<script>
import ContentHeader from '@/components/modules/ContentHeader'

export default {
  components: {
    ContentHeader,
  },
}
</script>

<style scoped>
.content-flow {
  width: 80%;
  padding: 5px 10px;

  border: 1px solid rgb(160, 179, 188);
  border-radius: 4px;
}

.content-flow a {
  font-weight: bold;

  text-decoration: none;

  color: #4d4d4d;
}

.flow-green {
  background-color: rgb(231, 248, 233);
}

.flow-blue {
  background-color: rgb(222, 236, 248);
}

.content-flow-arrow {
  font-size: 8px;

  width: 80%;
  padding: 2px 0;

  text-align: center;

  color: rgb(80, 172, 252);
}
</style>



// WEBPACK FOOTER //
// src/components/modules/guide/PurchaseFlow.vue